import React, { useRef, useState, useEffect, useCallback } from "react";
import styled, { css } from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import HeaderNavNew from "../../HeaderFotter/Header/HeaderNew.js";
import Fotter from "../../HeaderFotter/Fotter/Fotter.js";
// import FixedNav from "../../HeaderFotter/FixedNav/Fixednav.js";
import axiosInstance from "../../../axiosInstance.js";
import { ColorRing } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

gsap.registerPlugin(ScrollTrigger);

const sizes = {
  desktop: 1024,
  tablet: 768,
  phone: 576,
};

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.5;
  font-size: 20px;
  font-weight: 500;
  color: #7d7f78;
  box-sizing: border-box;
  overflow: hidden;
  `;
  // font-family: "Poppins", "Poppins Placeholder", sans-serif;

const Section = styled.section`
  flex: 1;
  width: 100%;
  padding-left: 50px;
  padding-right: 50px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const effect = (classname, delay = 0) => {
  gsap.from(classname, {
    opacity: 0,
    y: 20,
    duration: 2,
    ease: "power3.out",
    delay: delay,

    scrollTrigger: {
      trigger: classname,
      start: "top 80%",
      end: "bottom 80%",
      toggleActions: "play none none none",
      scrub: false,
      duration: 2,
    },
  });
};
const HomeNew = () => {
  const [isActive, setIsActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [gameStarted, setGameStarted] = useState(false);
  const [fastestAnswers, setFastestAnswers] = useState([]);
  const [players, setPlayers] = useState([]);
  const [remainingTime, setRemainingTime] = useState(20);
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  const [answeredPlayers, setAnsweredPlayers] = useState({});
  const [gameSummary, setGameSummary] = useState(null);
  const wsRef = useRef(null);
  const timerRef = useRef(null);
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [questionStarted, setQuestionStarted] = useState(false);
  const [needNewQuestion, setNeedNewQuestion] = useState(false);
  const [currentGameId, setCurrentGameId] = useState("game1");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // Hàm bắt đầu đếm ngược
  const startCountdown = useCallback(() => {
    console.log("Starting countdown...");
    // Đặt lại thời gian ban đầu là 20s
    setRemainingTime(20);
    setQuestionStarted(true);
    setNeedNewQuestion(false);
    
    // Reset trạng thái
    setShowCorrectAnswer(false);
    setAnsweredPlayers({});

    // Xóa interval cũ nếu có
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // Hàm cập nhật thời gian
    const updateTimer = () => {
      setRemainingTime(prev => {
        console.log("Current time:", prev);
        if (prev <= 0) {
          console.log("Time's up!");
          clearInterval(timerRef.current);
          setQuestionStarted(false);
          if (wsRef.current?.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify({ type: "get_answer" }));
            setShowCorrectAnswer(true);
          }
          return 0;
        }
        return prev - 1;
      });
    };

    // Bắt đầu interval đếm ngược mỗi giây
    timerRef.current = setInterval(updateTimer, 1000);
  }, []);

  useEffect(() => {
    const connectWebSocket = () => {
      if (wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) {
        return;
      }

      const wsUrl = `wss://wsgame.visgroup.co`;
      // const wsUrl = `ws://${window.location.hostname}:6789`;
      console.log("Connecting to:", wsUrl);
      wsRef.current = new WebSocket(wsUrl);

      wsRef.current.onopen = () => {
        console.log("Connected to game server!");
        setIsLoading(false);
      };

      wsRef.current.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          console.log("Received websocket data:", data);

          if (data.type === "ping") {
            wsRef.current.send(JSON.stringify({ type: "pong" }));
            return;
          }

          if (data.type === "admin_login_response") {
            if (data.success) {
              setIsLoggedIn(true);
              localStorage.setItem("admin_username", username);
              toast.success(data.message);
            } else {
              toast.error(data.message);
            }
            return;
          }

          if (data.type === "game_state") {
            console.log("Game state update received");
            setGameStarted(data.game_started);
            console.log("Game started:", data.game_started);
            
            // Nếu có câu hỏi
            if (data.question) {
              // Chỉ cập nhật thông tin câu hỏi, không bắt đầu đếm ngược
              setCurrentQuestion(data.question);
            } else {
              console.log("No question data in game state");
            }

            if (!data.game_started) {
              console.log("Game ended or not started");
              if (timerRef.current) {
                clearInterval(timerRef.current);
                setRemainingTime(0);
              }
              setCurrentQuestion(null);
              setCurrentQuestionId(null);
              setShowCorrectAnswer(false);
              setQuestionStarted(false);
              
              // Nếu có game summary từ server
              if (data.game_summary) {
                setGameSummary(data.game_summary);
              }
            } else {
              setGameSummary(null);
            }
            
            setFastestAnswers(data.fastest_answers || []);
            if (data.show_correct_answer) {
              setShowCorrectAnswer(true);
            }
            
            if (data.players) {
              setPlayers(data.players);
            }
            if (data.answered_players) {
              setAnsweredPlayers(data.answered_players);
            }
            setIsLoading(false);
          }

          // Handle answer result from server
          if (data.type === "answer_result") {
            console.log("Answer result received");
            setShowCorrectAnswer(true);
            if (data.fastest_answers) {
              setFastestAnswers(data.fastest_answers);
            }
          }
        } catch (err) {
          console.error("Error parsing message:", err);
        }
      };
    };

    connectWebSocket();

    // Check if user was previously logged in
    const savedUsername = localStorage.getItem("admin_username");
    if (savedUsername) {
      setUsername(savedUsername);
      setIsLoggedIn(true);
    }

    return () => {
      if (wsRef.current && !wsRef.current.intentionalClose) {
        console.log("Cleaning up WebSocket connection");
        wsRef.current.close();
        wsRef.current = null;
      }
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []); // Keep empty dependencies

  // Tạo effect riêng để xử lý game state
  useEffect(() => {
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      return;
    }

    // Gửi yêu cầu cập nhật game state
    wsRef.current.send(JSON.stringify({ type: "get_game_state" }));
  }, [gameStarted, currentQuestionId]); // Remove needNewQuestion from dependencies

  const handleStartGame = () => {
    console.log("Handle start game clicked");
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      toast.error("Không có kết nối đến server!");
      return;
    }

    if (players.length === 0) {
      toast.warning("Chưa có người chơi nào tham gia!");
      return;
    }

    // Reset states when starting new game
    setQuestionStarted(false);
    setCurrentQuestionId(null);
    
    console.log("Sending start_game message");
    wsRef.current.send(JSON.stringify({ 
      type: "start_game",
      game_id: currentGameId
    }));
    // Bắt đầu đếm ngược ngay khi bắt đầu game
    startCountdown();
  };

  const handleNextQuestion = () => {
    console.log("Handle next question clicked");
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      toast.error("Không có kết nối đến server!");
      return;
    }
    
    console.log(`Sending next_question message for game ${currentGameId}`);
    wsRef.current.send(JSON.stringify({ 
      type: "next_question",
      game_id: currentGameId
    }));
    // Bắt đầu đếm ngược ngay khi chuyển câu hỏi
    startCountdown();
  };

  const handleEndGame = () => {
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      toast.error("Không có kết nối đến server!");
      return;
    }

    wsRef.current.send(JSON.stringify({ type: "end_game" }));
  };

  const handleActivation = active => {
    setIsActive(active);
  };

  gsap.registerPlugin(useGSAP);

  useEffect(() => {
    // Function to check screen size and update state
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // 768px là kích thước bắt đầu của 'md' trong Tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    // Chắc chắn rằng window và document đều sẵn sàng
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      ScrollTrigger.refresh();
    }
  }, []);

  useEffect(() => {
    const imagesLoaded = document.querySelectorAll("img");
    const totalImages = imagesLoaded.length;
    let imagesLoadedCount = 0;

    imagesLoaded.forEach(image => {
      if (image.complete) {
        imagesLoadedCount++;
      } else {
        image.onload = () => {
          imagesLoadedCount++;
          if (imagesLoadedCount === totalImages) {
            // Khởi tạo ScrollTrigger sau khi tất cả hình ảnh đã tải xong
            ScrollTrigger.refresh();
          }
        };
      }
    });

    if (imagesLoadedCount === totalImages) {
      ScrollTrigger.refresh();
    }
  }, []);

  useGSAP(
    () => {
      // Phần loadingpage
      gsap.fromTo(
        ".loading-page",
        { opacity: 1 },
        {
          opacity: 0,
          display: "none",
          duration: 1.5,
          delay: 4,
        }
      );

      gsap.fromTo(
        ".name-container",
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 2,
          delay: 0.5,
        }
      );

      effect(".effect15");
      effect(".effect16");
      effect(".effect17");
      effect(".effect18", 0.5);
      effect(".effect19", 1);
    },
    // { scope: content }
  );

  const handleLogin = () => {
    if (!username.trim() || !password.trim()) {
      toast.error("Vui lòng nhập đầy đủ thông tin!");
      return;
    }

    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      toast.error("Không có kết nối đến server!");
      return;
    }

    wsRef.current.send(JSON.stringify({
      type: "admin_login",
      username: username,
      password: password
    }));
  };

  // If not logged in, show login screen
  if (!isLoggedIn) {
    return (
      <Container className="content bg-[#0d0d0d]">
        <HeaderNavNew onActive={handleActivation} />
        <Section>
          <div className="flex items-center justify-center h-full">
            <div className="bg-gray-800 p-8 rounded-lg w-full max-w-md">
              <h2 className="text-2xl font-bold text-yellow-300 mb-6 text-center">Đăng nhập</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-gray-300 mb-2">Tên đăng nhập</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="w-full p-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-yellow-500"
                    placeholder="Nhập tên đăng nhập"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-300 mb-2">Mật khẩu</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full p-3 rounded-lg bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-yellow-500"
                    placeholder="Nhập mật khẩu"
                  />
                </div>

                <button
                  onClick={handleLogin}
                  className="w-full py-3 px-6 bg-yellow-500 text-black rounded-lg font-bold hover:bg-yellow-400 transition-colors"
                >
                  Đăng nhập
                </button>
              </div>
            </div>
          </div>
        </Section>
        <Fotter />
        <ToastContainer />
        {isLoading && (
          <div className="fixed inset-0 bg-[rgb(75_81_99_/_80%)] flex justify-center items-center z-50">
            <ColorRing
              height={70}
              width={70}
              color="#4fa94d"
              ariaLabel="loading-indicator"
            />
          </div>
        )}
      </Container>
    );
  }

  return (
    <Container className="content bg-[#0d0d0d]">
      <HeaderNavNew onActive={handleActivation} />
      <Section>
        <div className="flex flex-col h-full pt-10">
          {/* Game Info Section */}
          <div className="mb-4">
            <div className="flex flex-col items-center text-center">
              <h2 className="max-w-[1500px]">
                <span
                  className="text-[30px] text-white"
                  >
                  Trả lời các câu hỏi vui về các thành viên trong Công ty gồm 2 phần chơi, mỗi phần 10 câu hỏi. <br /> Người chiến thắng mỗi phần chơi sẽ rinh về phần thưởng trị giá 500.000 VNĐ.
                </span>
              </h2>
              <div className="flex items-center gap-4 mt-4">
                <select
                  value={currentGameId}
                  onChange={(e) => setCurrentGameId(e.target.value)}
                  className="px-4 py-2 bg-gray-800 text-white rounded-lg border border-gray-700"
                  disabled={gameStarted}
                >
                  <option value="game1">Game 1</option>
                  <option value="game2">Game 2</option>
                </select>
                <p className="text-gray-400">
                  Số người chơi hiện tại: {players.length}
                </p>
              </div>
              {!gameStarted && (
                <button
                  onClick={handleStartGame}
                  className="mt-4 px-6 py-2 bg-yellow-500 text-black rounded-lg hover:bg-yellow-400 transition-colors"
                >
                  Bắt đầu Game
                </button>
              )}
            </div>
          </div>

          {/* Main Game Area */}
          <div className="flex gap-5 flex-1 min-h-0">
            {/* Left Panel */}
            <div className="flex flex-col bg-custom-gradient rounded-3xl p-6 text-white w-8/12 border-solid border-[1px] border-[#262626]">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl text-yellow-300">
                  {!gameStarted ? 'Danh sách người chơi' : 'Trò chơi đang diễn ra'}
                </h3>
                <div className="flex gap-3">
                  {!gameStarted ? (
                    <button
                      onClick={handleStartGame}
                      disabled={players.length === 0}
                      className={`px-4 py-2 rounded-lg font-bold transition-colors ${
                        players.length === 0
                          ? 'bg-gray-600 cursor-not-allowed'
                          : 'bg-green-600 hover:bg-green-500 text-white'
                      }`}
                    >
                      Bắt đầu Game
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={handleNextQuestion}
                        className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-500 transition-colors"
                      >
                        Câu tiếp theo
                      </button>
                      <button
                        onClick={handleEndGame}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-500 transition-colors"
                      >
                        Kết thúc
                      </button>
                    </>
                  )}
                </div>
              </div>

              <div className="flex-1 min-h-0 overflow-auto custom-scrollbar">
                {/* Chỉ hiển thị danh sách người chơi khi chưa bắt đầu game */}
                {!gameStarted && (
                  <>
                    {players.length > 0 ? (
                      <div className="grid grid-cols-3 gap-4 p-2">
                        {players.map((player, index) => (
                          <div
                            key={player.id}
                            className="bg-gray-800 p-4 rounded-lg"
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-gray-300">
                                {index + 1}. {player.username}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center text-gray-400 p-4">
                        Chưa có người chơi tham gia
                      </div>
                    )}
                  </>
                )}

                {/* Hiển thị thông tin game khi đã bắt đầu */}
                {gameStarted && currentQuestion && (
                  <div className="p-2">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-xl text-yellow-300">Câu hỏi hiện tại</h3>
                      <div className={`px-4 py-2 rounded-full font-bold text-lg ${
                        remainingTime > 10 ? 'bg-green-600' : 
                        remainingTime > 5 ? 'bg-yellow-600' : 
                        'bg-red-600'
                      } transition-colors duration-300`}>
                        {Math.max(0, Math.ceil(remainingTime))}s
                      </div>
                    </div>
                    <div className="bg-gray-800 p-6 rounded-lg">
                      <p className="text-xl mb-6">{currentQuestion.question}</p>
                      <div className="grid grid-cols-2 gap-4">
                        {currentQuestion.answers.map((answer, index) => {
                          const answerLetter = String.fromCharCode(65 + index);
                          const isCorrect = showCorrectAnswer && answerLetter === currentQuestion.correct;
                          return (
                            <div
                              key={index}
                              className={`p-4 rounded-lg text-center transition-colors ${
                                isCorrect ? 'bg-green-600' : 'bg-gray-700'
                              }`}
                            >
                              <span className={`mr-2 ${isCorrect ? 'text-white' : 'text-yellow-500'}`}>
                                {answerLetter}:
                              </span>
                              <span className={isCorrect ? 'text-white' : 'text-gray-300'}>
                                {answer}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Panel */}
            <div className="flex flex-col bg-custom-gradient rounded-3xl p-6 text-white w-4/12 border-solid border-[1px] border-[#262626]">
              <div className="flex items-center justify-center gap-2 mb-4">
                <img
                  src="/Img/icon/icon.png"
                  className="w-[22px] h-[22px]"
                  alt=""
                />
                <div className="text-yellow-300 text-xl font-bold">
                  {gameStarted ? 'Kết quả trả lời' : gameSummary ? 'Tổng kết trò chơi' : 'Tham gia game'}
                </div>
              </div>

              <div className="flex-1 min-h-0 overflow-auto custom-scrollbar">
                {gameStarted ? (
                  <div className="flex flex-col gap-4 p-2">
                    {fastestAnswers.length > 0 ? (
                      <div className="space-y-2">
                        {fastestAnswers.map((answer, index) => (
                          <div
                            key={index}
                            className="bg-green-900/50 p-3 rounded-lg flex justify-between items-center"
                          >
                            <div className="flex items-center gap-2">
                              <span className="text-green-400">{index + 1}.</span>
                              <span className="text-gray-300">{answer.username}</span>
                            </div>
                            <div className="flex items-center gap-3">
                              <span className="text-green-400 font-bold">{answer.answer}</span>
                              <span className="text-green-400/80 text-sm">{answer.time}s</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center text-gray-500">
                        Chưa có người trả lời
                      </div>
                    )}
                  </div>
                ) : gameSummary ? (
                  <div className="flex flex-col gap-6 p-2">
                    {/* Người chơi có điểm cao nhất */}
                    <div>
                      <h4 className="text-yellow-300 mb-3">Bảng xếp hạng</h4>
                      <div className="space-y-2">
                        {gameSummary.top_players?.map((player, index) => (
                          <div key={index} className="bg-gray-800/50 p-3 rounded-lg">
                            <div className="flex justify-between items-center">
                              <div className="flex items-center gap-2">
                                <span className={index === 0 ? "text-yellow-400" : index === 1 ? "text-gray-300" : "text-orange-400"}>
                                  {index + 1}.
                                </span>
                                <span className="text-gray-300">{player.username}</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="text-green-400">{player.correct_answers} đúng</span>
                                <span className="text-gray-400">|</span>
                                <span className="text-blue-400">TB {player.avg_time.toFixed(2)}s</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Người trả lời nhanh nhất */}
                    <div>
                      <h4 className="text-yellow-300 mb-3">Trả lời nhanh nhất</h4>
                      <div className="space-y-2">
                        {gameSummary.fastest_players?.map((player, index) => (
                          <div key={index} className="bg-gray-800/50 p-3 rounded-lg">
                            <div className="flex justify-between items-center">
                              <span className="text-gray-300">{player.username}</span>
                              <span className="text-blue-400">{player.fastest_time.toFixed(2)}s</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center p-2">
                    <h3 className="text-yellow-300 text-xl mb-4">
                      Quét mã QR để tham gia
                    </h3>
                    <div className="flex justify-center">
                      <img
                        src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(window.location.origin + "/game")}`}
                        alt="QR Code"
                        className="w-48 h-48"
                      />
                    </div>
                    <p className="text-gray-400 mt-4">
                      Hoặc truy cập: {window.location.origin}/game
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Fotter />
      <ToastContainer />
      {isLoading && (
        <div className="fixed inset-0 bg-[rgb(75_81_99_/_80%)] flex justify-center items-center z-50">
          <ColorRing
            height={70}
            width={70}
            color="#4fa94d"
            ariaLabel="loading-indicator"
          />
        </div>
      )}
    </Container>
  );
};

export default HomeNew;
